import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY, empty, of } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";
import { ApplicationType, EntityType } from "src/app/api/models";
import { EntityParameterService, InsurerService, QuestionnaireService } from "src/app/api/services";
import { AppState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { setInsurerDobType, setInsurerPhoneNumber, setInsurerWebLink } from "../../transaction-info/state/transaction-info.actions";
import * as InsurerActions from "./insurer.actions";
import { loadInsurerParamsFailure, loadInsurerParamsSuccess } from "./insurer.actions";

@Injectable()
export class InsurerEffects {
	constructor(private actions$: Actions, private insurerService: InsurerService, private store: Store<AppState>, private questionService: QuestionnaireService,
		private entityParameterService: EntityParameterService) { }

	public loadInsurerList$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(InsurerActions.loadInsurerList),
			mergeMap(() =>
				this.insurerService.insurerGetAllForDeclarationProcess().pipe(
					map((insurers) => InsurerActions.loadInsurerListSuccess({ data: insurers })),
					catchError((err) => of(InsurerActions.loadInsurerListFailure({ error: err })))
				)
			)
		);
	});



	public loadInsurerParams$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(InsurerActions.loadInsurerParams),
			switchMap(({ insurerId, langCode }) => {
				return this.entityParameterService.entityParameterGetAsDto({
					entityId: insurerId, entityType: EntityType.Ic,
					parameterName: environment.kioskMode ? "BirthDateBehaviorKiosk" : "BirthDateBehaviorHome", applicationType: ApplicationType.Hospi
				}).pipe(
					map((val) =>this.store.dispatch(setInsurerDobType({ dobType: val?.parameterValue?.toUpperCase() }))),
					switchMap((_) => {
						if (langCode == undefined)
							return of(EMPTY);

						return this.entityParameterService.entityParameterGetAsDto({
							entityId: insurerId, entityType: EntityType.Ic,
							applicationType: ApplicationType.Hospi, parameterName: "ChannelPhone" + langCode
						}).pipe(
							map((data) => {
								this.store.dispatch(setInsurerPhoneNumber({ data: data?.parameterValue }));
							})
						);
					}),
					switchMap((_) => {
						if (langCode == undefined)
							return of(EMPTY);

						return this.entityParameterService.entityParameterGetAsDto({entityId: insurerId, parameterName:  "WebLink" + langCode,
						applicationType: ApplicationType.Hospi, entityType: EntityType.Ic}).pipe(
							map((data) => {
								this.store.dispatch(setInsurerWebLink({ data: data?.parameterValue }));
							})
						);
					}),
					switchMap((_) =>of(loadInsurerParamsSuccess())),
					catchError((err) =>of(loadInsurerParamsFailure({ error: err })))
				);
			})
		);
	});
}
